import React from "react";
import "./ChemIndexDashboardBarChart.scss";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Label,
  Legend,
} from "recharts";

const COLORS = [
  "#1b6cd8", // Primary blue
  "#1f9fe7", // Sky blue
  "#25b2dc", // Cyan
  "#0d2340", // Navy
  "#3f8ef9", // Bright blue
  "#38bdf8", // Light blue
  "#5b7290", // Slate blue
];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${payload[0].name}`}</p>
        <p className="value">{`${payload[0].value.toLocaleString()}`}</p>
      </div>
    );
  }
  return null;
};

const ChemIndexDashboardBarChart = ({ isGetDashboardCountsFetching, data }) => {
  const countsData = data || [];
  
  const processedData = countsData.map(item => ({
    ...item,
    name: item.label.replace("Total", "").replace("ChemProducts", "Products"),
    value: item.value
  }));

  const totalCount = processedData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="dashboard-chart-wrapper">
      {isGetDashboardCountsFetching ? (
        <div className="spinner-wrapper">
          <div className="modern-spinner"></div>
          <p className="spinner-text">Loading insights...</p>
        </div>
      ) : countsData.length === 0 ? (
        <div className="no-data">No data available</div>
      ) : (
        <div className="dashboard-flex-container">
          {/* Main Chart Section */}
          <div className="chart-main-content">
            <ResponsiveContainer width="100%" height={450}>
              <PieChart>
                <Pie
                  data={processedData}
                  cx="50%"
                  cy="50%"
                  innerRadius={100}
                  outerRadius={140}
                  paddingAngle={4}
                  dataKey="value"
                  animationDuration={1500}
                  label={({ name, percent }) => `${name} (${(percent * 100).toFixed(1)}%)`}
                >
                  {processedData.map((entry, index) => (
                    <Cell 
                      key={`cell-${index}`} 
                      fill={COLORS[index % COLORS.length]} 
                      stroke="#fff"
                      strokeWidth={2}
                    />
                  ))}
                  <Label
                    value={totalCount.toLocaleString()}
                    position="center"
                    className="center-total-value"
                  />
                  <Label
                    value="Items Total"
                    position="center"
                    dy={28}
                    className="center-total-label"
                  />
                </Pie>
                <Tooltip content={<CustomTooltip />} />
                <Legend 
                  verticalAlign="bottom" 
                  align="center" 
                  iconType="circle"
                  wrapperStyle={{ paddingTop: "20px", fontSize: "13px", fontWeight: 500 }}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>

          {/* Detailed Breakdown Side Section */}
          <div className="detailed-breakdown-section">
            <h4 className="section-title">Detailed Breakdown</h4>
            <div className="breakdown-cards-list">
              {processedData.map((item, idx) => (
                <div className="breakdown-card-item" key={idx}>
                  <div className="card-left">
                    <span 
                      className="indicator-dot" 
                      style={{ backgroundColor: COLORS[idx % COLORS.length] }}
                    ></span>
                    <span className="item-name">{item.name}</span>
                  </div>
                  <div className="card-right">
                    <span className="item-value">{item.value.toLocaleString()}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChemIndexDashboardBarChart;
